export const MOBILE_ENHANCEMENT_INCLUDE_CLASSNAME = 'katal-mobile-enhancements-include';
export const safeMatchMedia = window?.matchMedia ?? function () {
  return {
    matches: false,
    addEventListener: () => {},
    removeEventListener: () => {}
  };
};
export const mobileMediaQuery = safeMatchMedia('(max-width: 720px)');
export const hasMobileIncludeClass = () => !!document.querySelector('.katal')?.classList.contains(MOBILE_ENHANCEMENT_INCLUDE_CLASSNAME) || !!document.body?.classList.contains(MOBILE_ENHANCEMENT_INCLUDE_CLASSNAME);
export const isMobile = () => mobileMediaQuery?.matches && hasMobileIncludeClass();
let KATAL_IS_LISTENING_FOR_VISUAL_VIEWPORT_RESIZE = false;
const visualViewportResizeListener = () => {
  const vh = window.visualViewport.height * 0.01;
  document.documentElement.style.setProperty('--kat-vh', `${vh}px`);
};
export const addVisualViewportResizeListener = () => {
  if (KATAL_IS_LISTENING_FOR_VISUAL_VIEWPORT_RESIZE) {
    return;
  }
  window.visualViewport?.addEventListener('resize', visualViewportResizeListener);
  KATAL_IS_LISTENING_FOR_VISUAL_VIEWPORT_RESIZE = true;
};
//# sourceMappingURL=mobile-helpers.js.map